export const formatTenderKind = (kind) => {
  if (kind === "void" || kind === "refund") return "refund";
  return kind;
};
